import { RouteRecordRaw } from "vue-router";

const topSellingReport: RouteRecordRaw = {
  path: "topSellingReport",
  component: () => import("@/views/reports/index.vue"),
  meta: {
    title: "تقرير المنتجات الأكثر مبيعا  ",
  },
  children: [
    {
      path: "",
      alias: "index",
      name: "index-topSellingReport",
      component: () =>
        import("@/views/reports/topSellingReport/pages/index.vue"),
      meta: {
        pageId: 18010400,
        role: "view",
        title: "تقرير المنتجات الأكثر مبيعا ",
      },
    },
  ],
};

export default topSellingReport;
